export const PAGE_SIZE = 20;

export enum WorkersSearchFormFields {
  SEARCHED_PROVIDER_ID = 'searchedProviderId',
  REFERENCE = 'reference',
  WORKER_NAME_OR_NISS = 'workerNameOrNiss',
  IS_ACTIVE = 'isActive',
  MISSING_CONTRACT = 'missingContract',
}
